import { getLinearSettings } from "./helper.ts";
import type { ChartStyleSettings } from "../../../../../../../api/types/svTypes.ts";

export function getGridMode(settings: ChartStyleSettings) {
  return getLinearSettings(settings)?.gridMode || "horizontal";
}
